module.exports = __webpack_public_path__ + "static/media/rubik-v9-latin-500.9ac3d9de.woff2";